import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
import { orgapi } from '../../ApiNames';


export const fetchDataSuccess = (countrylist: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: countrylist,
});

export const fetchDatasearch2Success = (search2: any) => ({
    type: 'FETCH_DATA_SEARCH2_SUCCESS',
    payload: search2,
});
//To get list of officers data
export const fetchData = () => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {}
            const apiname = orgapi.orgcountry;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

export const fetchDatasearch2 = (uid:any,catIds:any,firstnames:any,locations:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {userid:uid,country:catIds,firstname:firstnames,location:locations}
            const apiname = orgapi.orgsaerchfund;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDatasearch2Success(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

